export enum SiteMenuSection {
  Tours = 'Tours',
  Offices = 'Offices',
  CorporateServices = 'CorporateServices'
}

